import BuilderView from './BuilderView';
import EditView from './EditView';
import ReadOnlyView from './ReadOnlyView';

import {
  ExcludeId,
  TextInputElementDefinition,
} from '../../../../types/shared/EvaluationForm';

// This probably should go somewhere else.
export let DefaultAttribute: ExcludeId<TextInputElementDefinition> = {
  type: 'TextInputElement',
  question: '',
  label: '',
};

export default {
  builder: BuilderView,
  edit: EditView,
  readOnly: ReadOnlyView,
};
